var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "tsw",
      class: { on: _vm.value },
      attrs: { title: _vm.title, role: "switch" },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [_c("span", { staticClass: "knob" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }